import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appEmiratesIdFormatter]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EmiratesIdFormatterDirective),
      multi: true
    }
  ]
})
export class EmiratesIdFormatterDirective implements ControlValueAccessor {
  private onChange = (value: string) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, '');
    
    if (value.length > 15) {
      value = value.substring(0, 15);
    }
    
    const formattedValue = this.formatEmiratesId(value);
    input.value = formattedValue;
    
    this.onChange(value);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [8, 9, 27, 13, 46, 37, 38, 39, 40];
    const isCtrlKey = event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode);
    const isNumber = (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);
    
    if (!allowedKeys.includes(event.keyCode) && !isCtrlKey && !isNumber) {
      event.preventDefault();
    }
  }

  private formatEmiratesId(value: string): string {
    if (!value) return '';
    
    if (value.length <= 3) {
      return value;
    } else if (value.length <= 7) {
      return `${value.slice(0, 3)}-${value.slice(3)}`;
    } else if (value.length <= 14) {
      return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
    } else {
      return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 14)}-${value.slice(14)}`;
    }
  }

  writeValue(value: any): void {
    if (value != null) {
      const numericValue = value.toString().replace(/[^0-9]/g, '');
      this.el.nativeElement.value = this.formatEmiratesId(numericValue);
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }
}
